import axios from 'axios';
import moment from 'moment';

class BaseMitAuthService {
  constructor() {};

  //This is the duo expire time for the admin area currently
  isAdminTicketExpired(epochTime){
      let expireDate = moment.utc(epochTime);
      return moment.utc().isAfter(expireDate);
  }

  updateDuoToken(returnUrl){
      window.location.href = '/auth/duo?returnUrl='+returnUrl;
  }
  //
  // getCookie(name) {
  //     var nameEQ = name + "=";
  //     var ca = document.cookie.split(';');
  //     for(var i=0;i < ca.length;i++) {
  //         var c = ca[i];
  //         while (c.charAt(0)==' ') c = c.substring(1,c.length);
  //         if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  //     }
  //     return null;
  // }
  //
  // decodeCookie(encodedToken) {
  //     let token = {};
  //     token.header = JSON.parse(window.atob(encodedToken.split('.')[0]));
  //     token.payload = JSON.parse(window.atob(encodedToken.split('.')[1]));
  //     return token
  // }


}

export default BaseMitAuthService;
